// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
   //apiUrl: 'http://localhost:8080',
  apiUrl: 'https://admin-api-stage.b4a.com.br',
  // Google email-based login: PUBLIC OAuth Web client id (not a secret).
  // Reuses the shared B4A client (project b4a-prj-allocation-stg) — the same
  // one used by the Allocation tool. Each frontend origin must be authorized
  // on that OAuth client. Empty hides the Google button (password login
  // remains). Central login authz (B4A MCP) is checked server-side by
  // admin-api on /login/google.
  googleClientId:
    '89674853213-ghvbcbj9if5b749vabev1sokp58m7113.apps.googleusercontent.com',
  subscriptionApiUrl: 'https://subscription-api-stage.b4a.com.br/',
  // Stage Mill/QA has no prod pedidov. Ver rastreio uses the same gateway as prod.
  trackingApiUrl: 'https://gateway-api-prod.b4a.com.br/',
  instagramUrl: 'https://instagram.com/',
  connectFirebase: {
    projectId: 'b4astage-cb80a',
    appId: '1:925318835135:web:5fdea0da32656c1b2dcf0a',
    storageBucket: 'b4astage-cb80a.appspot.com',
    locationId: 'southamerica-east1',
    apiKey: 'AIzaSyADyiL4mMWKp0zqVbX_lZy-oYChSpwoNzM',
    authDomain: 'b4astage-cb80a.firebaseapp.com'
  },
  shopProductsBucket: 'b4a-stage-products',
  elasticSearch: {
    url: 'https://a2bb4426e59548a78607bb5a78c4e8cc.us-central1.gcp.cloud.es.io:443',
    credential: 'TzNYS2RZY0J0M3dXQS1YS3VsY006Vkx6aG9mMDJTSzZGOEt4Vk9ZcjVKZw=='
  },
  vertexConfig: {
    url: 'https://southamerica-east1-b4astage-cb80a.cloudfunctions.net/vertex',
    token: ''
  },
  hasura: {
    endpoint: 'https://hasura-products-36m4jjtkna-rj.a.run.app/v1/graphql',
    adminSecret: 'b171ab4d722455b03648ed462b41f8c2'
  },
  // Curadoria (product screen): fornecedores from b4a-connect-api. The
  // validade (expiration) is fetched via admin-api (apiUrl), which queries
  // Millenium server-side, so no ERP token is exposed on the front.
  // connectApiToken is a static service token (exposed in the bundle like the
  // Hasura adminSecret above) — keep it low-privilege and rotate via Secret
  // Manager; it must match INTERNAL_SERVICE_TOKENS in b4a-connect-api.
  curadoria: {
    connectApiUrl: 'https://connect-stage.b4a.ai/api',
    connectApiToken: '74942004351520286b92769db7163e2a147a9e1d0cd28727c181d8edbc8760ec'
  },
  apiBadge: {
    gateway: 'https://apiglamapp.glambox.com.br',
    credentials: {
      username: 'tecnologia@b4agroup.com',
      password: 'z#jruzVBq5dZd9'
    }
  },
  firebaseRegion: 'southamerica-east1',
  auditApiUrl: 'https://audit-microservice-dot-b4astage-cb80a.rj.r.appspot.com',
  glamUrl: 'https://glam-develop.web.app',
  mensUrl: 'https://mensmarket-frontend-stage.web.app/',
  shopGatewayId: 15,
  websocketUrl: 'https://websocket-stage.b4a.com.br/open/socket',
  errorModalBucket: 'b4a-stage-modal-errors'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
